import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useStore} from "../../utils/store";
import ContactForm from "./ContactForm";
import CircleCross from "../../assets/svg/circleCross.inline.svg";
import PhoneIcon from '../../assets/svg/phone.inline.svg';
import MailIcon from '../../assets/svg/mail.inline.svg';
import Image from "../atoms/Image";
import {formatPhoneString} from "../../utils/helpers";

const Holder = styled.div`
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 1rem;
  }
  @media ( ${props => props.theme.breakpoints.lg} ) {
    padding: 3rem;
  }
`;

const Inner = styled.div`
  background-color: ${props => props.theme.colours.grey4};
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  @media ( ${props => props.theme.breakpoints.md} ) {
    border-radius: 2rem;
    max-width: 56rem;
    position: relative;
    grid-template-columns: 2fr 3fr;
    overflow: hidden;
  }

  h1 {
    color: ${props => props.theme.colours.green};
    ${props => props.theme.fluidType(3)};
  }

  .submit-message {
    margin: 3rem 0;
    color: ${props => props.theme.colours.green};
    @media ( ${props => props.theme.breakpoints.md} ) {
      margin: 1rem 0;
    }
  }

  form {
    input[type="submit"] {
      margin-top: 1.5rem;
    }
  }
`;

const Col1 = styled.div`
  color: ${props => props.theme.colours.white};
  background-color: ${props => props.theme.colours.green};
  padding: 1.5rem;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 3rem;
    display: flex;
    flex-direction: column;
  }

  h2 {
    margin-top: 0;
    @media ( ${props => props.theme.breakpoints.md} ) {
      margin-bottom: 3rem;
    }
  }

  p {
    margin: 0 0 1rem 0;
  }

  .last-button {
    margin-bottom: 0;
    @media ( ${props => props.theme.breakpoints.md} ) {
      margin-bottom: 1rem;
    }
  }
`;

const Col2 = styled.div`
  padding: 1.5rem;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 3rem 6rem 3rem 3rem;
  }

  h3 {
    margin-top: 0;
  }
`;

const CloseHolder = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  @media ( ${props => props.theme.breakpoints.md} ) {
    position: absolute;
  }

  svg {
    path, circle {
      stroke: ${props => props.theme.colours.black4};
      @media ( ${props => props.theme.breakpoints.md} ) {
        stroke: ${props => props.theme.colours.green};
      }
    }
  }
`;

const ImageHolder = styled.div`
  display: none;
  @media ( ${props => props.theme.breakpoints.md} ) {
    display: block;
    margin-top: auto;
  }

  img {
    width: 100%;
  }
`;

function PopupForm() {
    const [submitMsg, setSubmitMsg] = useState(false);
    const contactOpen = useStore(state => state.contactOpen);
    const closeContact = useStore(state => state.closeContact);
    const customContact = useStore(state => state.customContact);
    const setCustomContact = useStore((state) => state.setCustomContact)
    const [phone, setPhone] = useState('978.288.1105');
    const [email, setEmail] = useState('info@highlandfleets.com');

    useEffect(() => {
        if (customContact) {
            if (customContact.phone) setPhone(customContact.phone)
            if (customContact.email) setEmail(customContact.email)
        } else {
            setPhone('978.288.1105')
            setEmail('info@highlandfleets.com')
        }
    }, [customContact]);

    if (!contactOpen) return null;
    return (
        <Holder>
            <Inner>

                <Col1>
                    <h2>Contact</h2>
                    <p><a className="button textWithIcon iconLeft"
                          href={`tel:+1${formatPhoneString(phone)}`}><PhoneIcon/>{phone}</a></p>
                    <p className="last-button"><a className="button textWithIcon iconLeft"
                                                  href={`mailto:${email}`}><MailIcon/>{email}</a></p>
                    <p className="last-button"><a className="button textWithIcon iconLeft"
                                                  href={`mailto:media@highlandfleets.com`}><MailIcon/>media@highlandfleets.com</a>
                    </p>
                    <ImageHolder>
                        <Image imgName="bus-white-outline.png"/>
                    </ImageHolder>
                </Col1>

                <Col2>
                    {!submitMsg && <h3>Or leave us your info, and our team will be in touch.</h3>}
                    <ContactForm submitMsg={submitMsg} submitMsgHandler={(message) => setSubmitMsg(message)}/>
                </Col2>

                <CloseHolder>
                    <button aria-label="Close the pop-up" onClick={() => {
                        closeContact()
                        setCustomContact(null)
                    }} className="button icon"><CircleCross/>
                    </button>
                </CloseHolder>

            </Inner>
        </Holder>
    )
}

export default PopupForm;